import React from "react";
import GetChessBoard from "../ReusableParts/GetChessBoard";
import { FaChessQueen } from "react-icons/fa";
import Cell from "./Cell";
import "./index.css";
type Props = {
  Board: Boolean[][];
};

function ChessBoard({ Board }: Props) {
  // console.log(Board);
  return (
    <div className="SudokuBoard">
      {Board.map((row, index) => (
        <div className="SudokuBoardRow">
          {row.map((col, indexCol) => (
            <Cell
              key={index + "," + indexCol}
              isBlack={(index + indexCol) % 2 == 0}
              pieceHere={col}
            />
          ))}
        </div>
      ))}
    </div>
  );
}

export default ChessBoard;
